export default {"src":"/_next/static/media/ml-logo-tagline.e9465e2d.svg","height":567,"width":748,"blurWidth":0,"blurHeight":0};